// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "rsuite" + "." + "197912db2b6a349bbfb1" + ".min.css";
};